import { Error, Timeline } from '@mui/icons-material';
import { Box, List } from '@mui/material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import React from 'react';
import { Alert } from 'components/Alert/Alert';
import { useSecuritySettings } from 'features/settings/hooks/useSecuritySettings';
import { useSettingsModal } from 'contexts/SettingsModalContext/useSettingsModal';
import { SettingsListSubheader } from 'components/Settings/SettingsListSubheader';
import { LinkItem } from 'components/LinkItem/LinkItem';
import { SETTINGS_SECTION_IDS } from 'features/settings/types/types';
import DataPreferences from './DataPreferences';

export const SecuritySettings = () => {
  const { isSignatureError, resetSignatureError } = useSecuritySettings();
  const { isDesktop } = useDeviceType();
  const { translation } = useTranslationContext();
  const { openModal } = useSettingsModal();
  const handleModalOpen = () => {
    openModal(SETTINGS_SECTION_IDS.SECURITY, translation('data_usage_preferences'));
  };
  return (
    <>
      <Box role="main">
        <List aria-labelledby="security__settings-header">
          <SettingsListSubheader
            id="security__settings-header"
            isDesktop={isDesktop}
            aria-label={translation('security_settings_title')}
          >
            {translation('security_settings_title')}
          </SettingsListSubheader>
          {isDesktop ? (
            // On desktop, show the preferences directly in the list
            <DataPreferences />
          ) : (
            <LinkItem
              showLinkIcon={false}
              leftIcon={<Timeline color="secondary" />}
              isButton
              onClick={handleModalOpen}
            >
              {translation('data_usage_preferences')}
            </LinkItem>
          )}
        </List>
      </Box>
      {/* When the offline component is created, we should use that here
      https://wellframe.atlassian.net/browse/WFMOB-14050 */}
      <Alert
        isPresented={isSignatureError}
        variant="filled"
        severity="error"
        message={translation('error_loading_body')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        icon={<Error />}
        handleDismiss={resetSignatureError}
      />
    </>
  );
};
